export const GroupCreateSceneTranslation = {
  fi: {
    GroupCreateScene: {
      createGroup: 'Luo ryhmä',
      notSavedCheckFields: 'Ryhmää ei tallennettu. Tarkista kentät.',
    },
  },
};
